import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServicesAssignResourceColumnsModel} from "../../models/services-assign-resource-columns.model";
import {MissingItemDataModel, MissingItemModel} from "../../models/missing-item.model";

export class ServiceMissingItemTableComponent implements IController {
  missingItem: MissingItemModel;
  quantityLeft?: number;
  onRemove: Function;
  onChange: Function;

  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

  setEvents() {
    const div1 = document.getElementById('service-missing-items-table').querySelectorAll("#header")[0];
    const div2 = document.getElementById('service-missing-items-table').querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceMissingItemTable', {
    require: {
      form: '^form'
    },
    bindings: {
      missingItem: '<',
      quantityLeft: '<',
      onRemove: '&',
      onChange: '&'
    },
    template: require('./service-missing-item-table.html').default,
    controller: ServiceMissingItemTableComponent
  });
